import React, { useEffect } from 'react'

import {
  CssBaseline,
  LinearProgress,
  makeStyles,
  MuiThemeProvider,
  useTheme
} from '@material-ui/core'
import { Header, Main, SidePanel, SideNav } from '../../../components/layout/components/index'
import { styles } from './defaultLayout.styles'

import {
  EventConfiguration,
  EventSaveType,
  NotifyProvider,
  PageEventsConfiguration
} from '@globaleris/ui.library'
import ReactGA from 'react-ga4'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ConfirmationDialog } from '../../../components/confirmationDialog/confirmationDialog'
import { AuthRoutes } from '../../../model'
import { AppConfigurationKey } from '../../../model/enums/appConfigurationKey'
import {
  getAppConfigurationValue,
  getCustomerDomainPrefix,
  getUserName,
  RootStoreModel,
  storeLayout
} from '../../../redux'
import { getAppKeyValuePairs } from '../../../services/appConfiguration.service'
import { getToken } from '../../../auth'
import { envConfig } from '../../../config/envConfig'
//import { useNotify } from '@globaleris/ui.library';

export interface DefaultLayoutProps {
  logoutHandler: () => void
}

const DefaultLayout: React.FC<DefaultLayoutProps> = ({ logoutHandler }) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  //const { updateNotifyContext } = useNotify();

  let history = useHistory()

  const autoCollapse = useSelector(
    (state: RootStoreModel) => state.layout && state.layout.sideNavAutoCollapse
  )

  const appConfiguration = useSelector(
    (state: RootStoreModel) => state.appConfiguration && state.appConfiguration
  )

  const [sideNavAutoCollapse, setSideNavAutoCollapse] = React.useState<boolean>(autoCollapse)
  const [isLoading, setIsLoading] = React.useState<boolean>(true)
  const [headerClick, setHeaderClick] = React.useState<boolean>(true)
  const [token, setToken] = React.useState<string | null>(null)

  useEffect(() => {
    storeLayout(sideNavAutoCollapse)
  }, [sideNavAutoCollapse])

  useEffect(() => {
    const getAppConfiguration = async () => {
      getAppKeyValuePairs().then(success => {
        if (!success) {
          //history.push(AuthRoutes.ERROR);
        } else {
          const gaID = getAppConfigurationValue(AppConfigurationKey.ReactGA)
          //const gaID = 'UA-80211534-2';
          if (gaID) {
            ReactGA.initialize(gaID)
          }
        }
      })
    }

    getAppConfiguration()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    storeLayout(sideNavAutoCollapse)
  }, [sideNavAutoCollapse])

  useEffect(() => {
    const getUserProfile = async () => {
      // Load profile.service.ts dynamicly in order to wait appConfiguration key/values are loaded and can be used in module as global
      import(/* webpackMode: "eager" */ `../../../services/`)
        .then(loadedModule => {
          loadedModule.fetchUser(logoutHandler).then(success => {
            if (!success) {
              history.push(AuthRoutes.UNAUTHORIZED)
            }

            setIsLoading(false)
          })
        })
        .catch(error => {
          console.log('Error importing profile.service.ts', error)
          history.push(AuthRoutes.ERROR)
        })
    }

    if (appConfiguration && appConfiguration.length > 0) {
      getUserProfile()
      // updateNotifyContext(`${getAppConfigurationValue(AppConfigurationKey.Host)}${getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixHub)}`,
      //   getAppConfigurationValue(AppConfigurationKey.Subscription));
    }

    //appConfiguration && appConfiguration.length > 0 &&  getUserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appConfiguration])

  const toggleAutoCollapseHandler = React.useCallback(() => {
    setSideNavAutoCollapse(!sideNavAutoCollapse)
  }, [sideNavAutoCollapse])

  const handleClickAway = () => {
    if (window.innerWidth <= 768) {
      setSideNavAutoCollapse(true)
    }
  }

  useEffect(() => {
    const fetchUserToken = async () => {
      getToken()
        .then(token => {
          setToken(token)
        })
        .catch(error => {
          console.log('Error fetching user token', error)
          history.push(AuthRoutes.ERROR)
        })
    }

    fetchUserToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //QUITAR ESTO DE AQUÍ. Llevarlo a un fichero de configuración o algo parecido a como están las pantallas.
  const pageEventsConfiguration: PageEventsConfiguration[] = [
    {
      page: 'Balance',
      events: [
        {
          event: 'UpdatedBalance',
          notify: false
        },
        {
          event: 'UpdatingBalance',
          notify: false
        },
        {
          event: 'UpdateFailedBalance',
          notify: false
        }
      ] as EventConfiguration[],
      saveType: EventSaveType.LastReceived
    },
    {
      page: 'invoicesTable',
      events: [
        {
          event: 'EjecucionCFProcessing',
          notify: false
        }
      ] as EventConfiguration[],
      saveType: EventSaveType.LastReceived
    }
  ]

  return (
    <>
      {!isLoading ? (
        <NotifyProvider
          subscriptionKey={envConfig.subscriptions.front ?? ''}
          hubUrl={`${getAppConfigurationValue(AppConfigurationKey.Host)}${getAppConfigurationValue(
            AppConfigurationKey.PrefixEnviromentFrontServices
          )}`}
          user={getUserName() ?? ''}
          domain={getCustomerDomainPrefix()}
          eventsConfiguration={pageEventsConfiguration}
          token={token ?? ''}
        >
          <div className={classes.root}>
            <CssBaseline />
            <Header onToggleAutoCollapse={toggleAutoCollapseHandler} clickAway={handleClickAway} />
            <SideNav autoCollapse={sideNavAutoCollapse} headerClicked={headerClick} />
            <SidePanel />
            <main className={classes.content}>
              <Main sideNavAutoCollapse={sideNavAutoCollapse} />
            </main>
            <ConfirmationDialog />
          </div>
        </NotifyProvider>
      ) : (
        <MuiThemeProvider theme={currentTheme}>
          <LinearProgress />
        </MuiThemeProvider>
      )}
    </>
  )
}

export default React.memo(DefaultLayout)
